export default __webpack_public_path__ + "static/media/higher_frame_logo.d4d88d15.svg";